import React from "react";
import Menu from "../../components/Menu";
import More from "../../assets/img/mais.svg";
import Report from "../../assets/img/report-black.svg";
import ListCardProfessionalsReportPayments from "../../components/ListCardProfessionalsReportPayments.js";
import moment from "moment";
import { Link } from "react-router-dom";
function ReportPaymentSchedulings() {
  const [search, setSearch] = React.useState("");
  const [dateInitial, setDateInitial] = React.useState(
    moment().subtract(7, "days").format("YYYY-MM-DD")
  );
  const [dateFinal, setDateFinal] = React.useState(
    moment().format("YYYY-MM-DD")
  );
  const [reports, setReports] = React.useState([
    {
      name: "Relatório de Pagamentos",
      path: "/reports/paymentschedulings",
    },
  ]);
  const screenTela = (
    <div className="screenContainer" style={{ paddingRight: "0px" }}>
      <div className="row row-container">
        <h1 className="col-12">
          {" "}
          <img style={{ width: "40px" }} alt="svg" src={Report} />{" "}
          <span className="name-screen-title name-screen-professionals">
            Relatórios
          </span>{" "}
        </h1>

        <div className="row row-subcontainer">
          {reports.map((data, index) => {
            return (
              <Link
                key={index}
                to={data.path}
                className="col-12 col-sm-6 col-md-6 col-lg-4"
                style={{ padding: "0px 10px", cursor: "pointer" }}>
                <div>
                  <div
                    style={{
                      flexDirection: "column",
                      alignItems: "flex-start",
                    }}
                    className="card-list">
                    <span
                      style={{ textAlign: "start" }}
                      className="card-list-name truncated-text">
                      {data.name}
                    </span>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );

  return <Menu screen={screenTela} />;
}

export default ReportPaymentSchedulings;
